import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@openedx/paragon';
import { RiArrowLeftSLine } from '@remixicon/react';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from '../messages';

const ProgramBanner = ({ title, imageUrl, coursesLeft }) => {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <div
      className="program-inner__banner"
      style={{ backgroundImage: `url(${imageUrl})` }}
      role="img"
      aria-label={title}
    >
      <div className="program-inner__banner-overlay" aria-hidden />
      <IconButton
        src={RiArrowLeftSLine}
        alt={intl.formatMessage(messages.backToLearning)}
        onClick={() => navigate('/courses')}
        variant="inverse-tertiary"
        className="program-inner__banner-back"
      />
      <div className="program-inner__banner-content">
        <h1 className="program-inner__banner-title">{title}</h1>
        {coursesLeft > 0 && (
          <span className="program-inner__banner-meta">
            {intl.formatMessage(messages.coursesLeft, { count: coursesLeft })}
          </span>
        )}
      </div>
    </div>
  );
};

export default ProgramBanner;
